import React, { useState, useEffect, useCallback, useRef } from 'react';
import { format, parse } from 'date-fns';
import DateRangePicker from '@/components/ui/DateRangePicker';
import PagesWrapper from '@/components/ui/shared/PagesWrapper';
import { Card, CardContent } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Badge } from '@/components/ui/badge';
import { Search, X, Loader2 } from 'lucide-react';
import ListChartWidget from '../ListChartWidget';
import BarListChart from '../BarListChart';
import ColumnPieChart from '../ColumnPieChart';
import HeatmapChart from '../HeatmapChart';
import FilterTag_API from '../FilterTag_API';
import { userService } from '../../_services';
import { Redirect } from "react-router-dom";
import ColorJson from '../../../src/whitelabel.json';
import { safeParseDate } from '@/lib/utils';

function PublicAPI({ AnalyticData, handeChangefilter }) {
    // Initialize dates (7-day default for PublicAPI)
    const getInitialDates = () => {
        const defaultStartDate = new Date();
        defaultStartDate.setDate(defaultStartDate.getDate() - 7);
        const defaultEndDate = new Date();
        
        const storedStartDate = localStorage.getItem('User_Start_Date_API');
        const storedEndDate = localStorage.getItem('User_End_Date_API');
        
        const startdate = (storedStartDate && storedStartDate !== "" && storedStartDate !== "null")
            ? safeParseDate(storedStartDate, defaultStartDate)
            : defaultStartDate;
        const enddate = (storedEndDate && storedEndDate !== "" && storedEndDate !== "null")
            ? safeParseDate(storedEndDate, defaultEndDate)
            : defaultEndDate;
        
        return {
            startDate: startdate,
            endDate: enddate
        };
    };

    const initialDates = getInitialDates();
    const [startDate, setStartDate] = useState(initialDates.startDate);
    const [endDate, setEndDate] = useState(initialDates.endDate);
    const [graphData, setGraphData] = useState([]);
    const [FilterTagList, setFilterTagList] = useState(() => {
        try {
            const stored = localStorage.getItem('Advance_Filter_API');
            return stored && stored !== "null" && stored !== "{}" ? stored : '';
        } catch {
            return '';
        }
    });
    const [userdata] = useState(() => {
        try {
            return JSON.parse(localStorage.getItem('user'));
        } catch {
            return null;
        }
    });
    const [searchDisplay, setSearchDisplay] = useState([]);
    const [searchValue, setSearchValue] = useState('');
    const [showSearchResults, setShowSearchResults] = useState(false);
    const [searchLoading, setSearchLoading] = useState(false);
    
    // Refs for click outside detection
    const searchInputRef = useRef(null);
    const searchResultsRef = useRef(null);

    // Calculate roletype, rolename, wh_Id
    const getRoleInfo = useCallback(() => {
        if (!userdata) return { roletype: '', rolename: '', wh_Id: 0 };
        
        return {
            roletype: userdata.userrole || '',
            rolename: userdata.paramsname || '',
            wh_Id: userdata.wholesaler_Id || 0
        };
    }, [userdata]);

    const roleInfo = getRoleInfo();

    const changeData = useCallback((dateChanged, stdate, endate) => {
        const APIBaseURL = '/api/publicAPI';
        let startDateObj = '';
        let endDateObj = '';
        
        if (dateChanged == undefined) {
            if (localStorage.getItem('User_Start_Date_API') != "" && localStorage.getItem('User_Start_Date_API') != null && localStorage.getItem('User_Start_Date_API') != undefined) {
                startDateObj = localStorage.getItem('User_Start_Date_API');
            } else {
                const startdate = new Date();
                startdate.setDate(startdate.getDate() - 7);
                startDateObj = startdate;
                endDateObj = endDate;
            }
            if (localStorage.getItem('User_End_Date_API') != "" && localStorage.getItem('User_End_Date_API') != null && localStorage.getItem('User_End_Date_API') != undefined) {
                endDateObj = localStorage.getItem('User_End_Date_API');
            } else {
                const startdate = new Date();
                startdate.setDate(startdate.getDate() - 7);
                startDateObj = startdate;
                endDateObj = endDate;
            }
        } else {
            startDateObj = stdate;
            endDateObj = endate;
        }

        let AdFilterJson = '';
        try {
            const filterData = localStorage.getItem('Advance_Filter_API');
            if (filterData && filterData !== 'null' && filterData !== 'undefined') {
                const parsed = JSON.parse(filterData);
                // Ensure parsed result is a valid object
                if (parsed && typeof parsed === 'object' && !Array.isArray(parsed)) {
                    AdFilterJson = parsed;
                    setFilterTagList(JSON.stringify(AdFilterJson));
                } else {
                    AdFilterJson = '';
                    setFilterTagList('');
                }
            } else {
                AdFilterJson = '';
                setFilterTagList('');
            }
        } catch (error) {

            AdFilterJson = '';
            setFilterTagList('');
        }
        
        const startDateFormatted = format(safeParseDate(startDateObj), "yyyyMMdd");
        const endDateFormatted = format(safeParseDate(endDateObj), "yyyyMMdd");
        const changedStartDate = format(parse(startDateFormatted, "yyyyMMdd", new Date()), "MM/dd/yyyy");
        const changedEndDate = format(parse(endDateFormatted, "yyyyMMdd", new Date()), "MM/dd/yyyy");
        setStartDate(changedStartDate);
        setEndDate(changedEndDate);
        
        const Request_user = "admin";
        const date_wise_total_public_api_call_RequestJson = "{\"wname\"" + ":\"" + Request_user + "\",\"start_date\"" + ":\"" + startDateFormatted + "\",\"end_date\"" + ":\"" + endDateFormatted + "\",\"rcount\"" + ":" + 90 + ",\"chart_type\"" + ":\"" + "columnList\"" + ",\"ispatientsaving\"" + ":\"" + "true\"" + ",\"pharmacynumber\"" + ":\"" + "all\"" + ",\"filtertime\"" + ":\"" + localStorage.getItem('Filter_Last_Update_Time_API') + "\",\"rxsClaimType\"" + ":\"" + localStorage.getItem('Updated_HD_Type_API') + "\"}";
        const whname_wise_total_public_api_call_RequestJson = "{\"wname\"" + ":\"" + Request_user + "\",\"start_date\"" + ":\"" + startDateFormatted + "\",\"end_date\"" + ":\"" + endDateFormatted + "\",\"rcount\"" + ":" + 90 + ",\"chart_type\"" + ":\"" + "pielist\"" + ",\"ispatientsaving\"" + ":\"" + "true\"" + ",\"pharmacynumber\"" + ":\"" + "all\"" + ",\"filtertime\"" + ":\"" + localStorage.getItem('Filter_Last_Update_Time_API') + "\",\"rxsClaimType\"" + ":\"" + localStorage.getItem('Updated_HD_Type_API') + "\"}";
        const endpoint_wise_total_public_api_call_RequestJson = "{\"wname\"" + ":\"" + Request_user + "\",\"start_date\"" + ":\"" + startDateFormatted + "\",\"end_date\"" + ":\"" + endDateFormatted + "\",\"rcount\"" + ":" + 90 + ",\"chart_type\"" + ":\"" + "pielist\"" + ",\"ispatientsaving\"" + ":\"" + "true\"" + ",\"pharmacynumber\"" + ":\"" + "all\"" + ",\"filtertime\"" + ":\"" + localStorage.getItem('Filter_Last_Update_Time_API') + "\",\"rxsClaimType\"" + ":\"" + localStorage.getItem('Updated_HD_Type_API') + "\"}";
        const api_response_wise_total_public_api_call_RequestJson = "{\"wname\"" + ":\"" + Request_user + "\",\"start_date\"" + ":\"" + startDateFormatted + "\",\"end_date\"" + ":\"" + endDateFormatted + "\",\"rcount\"" + ":" + 90 + ",\"chart_type\"" + ":\"" + "columnList\"" + ",\"ispatientsaving\"" + ":\"" + "true\"" + ",\"pharmacynumber\"" + ":\"" + "all\"" + ",\"filtertime\"" + ":\"" + localStorage.getItem('Filter_Last_Update_Time_API') + "\",\"rxsClaimType\"" + ":\"" + localStorage.getItem('Updated_HD_Type_API') + "\"}";
        const Table_topndc_public_api_call_RequestJson = "{\"wname\"" + ":\"" + Request_user + "\",\"start_date\"" + ":\"" + startDateFormatted + "\",\"end_date\"" + ":\"" + endDateFormatted + "\",\"rcount\"" + ":" + 30 + ",\"chart_type\"" + ":\"" + "list\"" + ",\"filtertime\"" + ":\"" + localStorage.getItem('Filter_Last_Update_Time_API') + "\",\"rxsClaimType\"" + ":\"" + localStorage.getItem('Updated_HD_Type_API') + "\"}";
        
        let primaryColor;
        let secondaryColor;
        let extraColor;
        if (window.location.host.split('.').slice(-2).join('.').toLowerCase() == "rxhacker.com" || window.location.host.split('.').slice(-2).join('.').toLowerCase() == "localhost:5464" || window.location.host.toLowerCase() == "tempfilter.23byt.es" || window.location.host.toLowerCase() == "reporting.nulifespanrx.com") {
            primaryColor = ColorJson.ApplicationColor.Rxhacker_primary_color;
            secondaryColor = ColorJson.ApplicationColor.Rxhacker_secondary_color;
            extraColor = ColorJson.ApplicationColor.Rxhacker_extra_color;
        } else {
            primaryColor = ColorJson.ApplicationColor.Glic_primary_color;
            secondaryColor = ColorJson.ApplicationColor.Glic_secondary_color;
            extraColor = ColorJson.ApplicationColor.Glic_extra_color;
        }
        
        setGraphData([
            {
                url: APIBaseURL + "/Total_API_Call",
                type: "Bar_List",
                title: "API Calls",
                Subtitle: "Total number of API calls received",
                ColorCode: secondaryColor,
                XlabelString: "Date",
                YlabelString: "# of Calls",
                id: "date_wise_total_public_api_call",
                RequestJson: date_wise_total_public_api_call_RequestJson,
                RequestJson1: JSON.stringify(AdFilterJson)
            },
            {
                url: APIBaseURL + "/WH_API_Call",
                type: "Column_Pie",
                title: "API Calls by Wholesaler",
                Subtitle: "Number of calls for each wholesaler",
                ColorCode: extraColor,
                XlabelString: "# of calls",
                YlabelString: "",
                DataType: "WholesalerName",
                id: "wholesaler_wise_total_public_api_call",
                RequestJson: whname_wise_total_public_api_call_RequestJson,
                RequestJson1: JSON.stringify(AdFilterJson)
            },
            {
                url: APIBaseURL + "/Endpoint_API_Call",
                type: "Column_Pie",
                title: "API Calls by Endpoint",
                Subtitle: "Number of calls for each endpoint",
                ColorCode: extraColor,
                XlabelString: "# of calls",
                YlabelString: "",
                DataType: "EndpointName",
                id: "endpoint_wise_total_public_api_call",
                RequestJson: endpoint_wise_total_public_api_call_RequestJson,
                RequestJson1: JSON.stringify(AdFilterJson)
            },
            {
                url: APIBaseURL + "/ResponseTime_API_Call",
                type: "Bar_List",
                title: "API Call Response Times",
                Subtitle: "Average response time for each endpoint",
                ColorCode: secondaryColor,
                XlabelString: "# API name",
                YlabelString: "Response Time (ms)",
                id: "response_time_wise_total_public_api_call",
                RequestJson: api_response_wise_total_public_api_call_RequestJson,
                RequestJson1: JSON.stringify(AdFilterJson)
            },
            {
                url: APIBaseURL + "/Top50NDC_API_Call",
                type: "List",
                title: "Top NDC's Searched",
                Subtitle: "Top 50 NDC's searched",
                ColorCode: extraColor,
                XlabelString: "",
                YlabelString: "",
                id: "top_NDC_searched",
                RequestJson: Table_topndc_public_api_call_RequestJson,
                RequestJson1: JSON.stringify(AdFilterJson)
            },
            {
                url: APIBaseURL + "/TimeOfDay_API_Call",
                type: "Heatmap",
                title: "API Calls by Time of Day",
                Subtitle: "Distribution of API calls throughout the day",
                ColorCode: "#ffba10",
                DataType: "Hourly request",
                id: "heatmap11",
                RequestJson: date_wise_total_public_api_call_RequestJson,
                RequestJson1: JSON.stringify(AdFilterJson)
            }
        ]);
    }, [startDate, endDate]);

    const handleCalendar = useCallback((e, picker) => {
        const changedStartDate = format(safeParseDate(picker.startDate), "MM/dd/yyyy");
        const changedEndDate = format(safeParseDate(picker.endDate), "MM/dd/yyyy");
        localStorage.setItem('User_Start_Date_API', changedStartDate);
        localStorage.setItem('User_End_Date_API', changedEndDate);
        changeData(true, changedStartDate, changedEndDate);
    }, [changeData]);

    // Search functionality using SearchOnTypeText_AnalyticAPI
    const searchAPI = useCallback(async (text) => {
        if (text.length < 2) {
            setSearchDisplay([]);
            setShowSearchResults(false);
            setSearchLoading(false);
            return;
        }
        
        setSearchLoading(true);
        
        try {
            const response = await fetch('/api/Filter/SearchOnTypeText_AnalyticAPI', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ 
                    text: text,
                    roletype: roleInfo.roletype || '',
                    rolename: roleInfo.rolename || '',
                    whname: roleInfo.wh_Id ? roleInfo.wh_Id.toString() : ''
                })
            });
            
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            
            const data = await response.json();

            // Defensive check: ensure data is an array
            if (Array.isArray(data) && data.length > 0) {
                setSearchDisplay(data);
                setShowSearchResults(true);
            } else {
                setSearchDisplay([]);
                setShowSearchResults(false);
            }
            setSearchLoading(false);
        } catch (error) {

            setSearchDisplay([]);
            setShowSearchResults(false);
            setSearchLoading(false);
        }
    }, [roleInfo]);

    const handleSearchChange = useCallback((e) => {
        const value = e.target.value;
        setSearchValue(value);
        searchAPI(value);
    }, [searchAPI]);

    const handleSearchFocus = useCallback(() => {
        if (searchValue.length >= 2 && searchDisplay.length > 0) {
            setShowSearchResults(true);
        }
    }, [searchValue, searchDisplay]);

    const handleSearchItemClick = useCallback((item) => {
        try {
            // Defensive checks for item properties
            if (!item || !item.ctype || !item.cvalue) {

                return;
            }
            
            setSearchValue('');
            setSearchDisplay([]);
            setShowSearchResults(false);
            
            // Create filter JSON - using ctype and cvalue from API response
            const nodetype = item.ctype;
            const nodevalue = item.cvalue;
            
            let filterData = {};
            try {
                const existingFilter = localStorage.getItem('Advance_Filter_API');
                if (existingFilter && existingFilter !== 'null' && existingFilter !== '{}') {
                    const parsed = JSON.parse(existingFilter);
                    // Ensure parsed result is an object
                    if (parsed && typeof parsed === 'object' && !Array.isArray(parsed)) {
                        filterData = parsed;
                    }
                }
            } catch (e) {

                filterData = {};
            }
            
            // Add to existing array or create new one
            if (filterData[nodetype]) {
                // Check if value already exists to avoid duplicates
                if (!filterData[nodetype].includes(nodevalue)) {
                    filterData[nodetype].push(nodevalue);
                }
            } else {
                filterData[nodetype] = [nodevalue];
            }
            
            localStorage.setItem('Advance_Filter_API', JSON.stringify(filterData));
            localStorage.setItem('Filter_Last_Update_Time_API', new Date().toString());
            
            // Refresh data with current dates
            const storedStart = localStorage.getItem('User_Start_Date_API');
            const storedEnd = localStorage.getItem('User_End_Date_API');
            
            const currentStart = storedStart || format(startDate, "MM/dd/yyyy");
            const currentEnd = storedEnd || format(endDate, "MM/dd/yyyy");
            
            changeData(true, currentStart, currentEnd);
        } catch (error) {

        }
    }, [startDate, endDate, changeData]);

    const getTagTypeFullName = useCallback((stext) => {
        // Map ctype values to display names
        const typeMap = {
            'Pharmacy Chain': 'Pharmacy Chain',
            'Wholesaler Name': 'Wholesaler Name',
            'Pharmacy Name': 'Pharmacy Name'
        };
        return typeMap[stext] || stext;
    }, []);

    const handlechangea = useCallback(() => {
        changeData();
        if (handeChangefilter) {
            handeChangefilter();
        }
    }, [changeData, handeChangefilter]);

    useEffect(() => {
        let newDate = new Date();
        localStorage.setItem('Filter_Last_Update_Time_API', newDate);
        changeData();
    }, []);

    // Click outside handler for search results
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (searchResultsRef.current && !searchResultsRef.current.contains(event.target) &&
                searchInputRef.current && !searchInputRef.current.contains(event.target)) {
                setShowSearchResults(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    // Auth checks
    const userType = userService.Get_User_Type();
    if (userService.Check_LoggedIn_Status() === 'Login') {
        return <Redirect to="/login" />;
    }
    if (['distributor', 'subadmin', 'wholesaler'].includes(userType?.toLowerCase())) {
        return <Redirect to='/pageNotFound' />;
    }

    return (
        <PagesWrapper>
            <div className="flex flex-col gap-4">
                <div className="flex items-center">
                    <h1 className="text-2xl font-semibold text-foreground">
                        Public API Analytics
                    </h1>
                </div>

                <Card>
                    <CardContent className="analytics-card-content">
                        <div className="flex flex-col gap-3 lg:flex-row lg:items-center lg:gap-4">
                            <DateRangePicker
                                className="w-full lg:w-[320px] h-10 shrink-0"
                                initialSettings={{
                                    startDate: format(startDate, "MM/dd/yyyy"),
                                    endDate: format(endDate, "MM/dd/yyyy"),
                                    maxDate: new Date(),
                                    locale: {
                                        format: 'MM/DD/YYYY'
                                    }
                                }}
                                onApply={handleCalendar}>
                                <div className="flex items-center gap-0 w-full lg:w-[320px] h-10 rounded-md overflow-hidden border border-input bg-card hover:shadow-sm transition-shadow">
                                    <div className="flex items-center gap-1 px-3 flex-1">
                                        <span className="text-sm text-muted-foreground whitespace-nowrap">From</span>
                                        <Input
                                            type="text"
                                            className="bg-transparent text-sm cursor-pointer w-full !border-0 outline-none h-auto p-0 rounded-none"
                                            value={format(startDate, "MM/dd/yyyy")}
                                            readOnly
                                        />
                                    </div>
                                    <div className="h-6 w-px bg-border flex-shrink-0" />
                                    <div className="flex items-center gap-1 px-3 flex-1">
                                        <span className="text-sm text-muted-foreground whitespace-nowrap">To</span>
                                        <Input
                                            type="text"
                                            className="bg-transparent text-sm cursor-pointer w-full !border-0 outline-none h-auto p-0 rounded-none"
                                            value={format(endDate, "MM/dd/yyyy")}
                                            readOnly
                                        />
                                    </div>
                                </div>
                            </DateRangePicker>

                            {/* Search - flexible width, grows to fill space */}
                            <div className="relative flex-1" ref={searchInputRef}>
                                <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground pointer-events-none" />
                                <Input
                                    type="text"
                                    placeholder="Search wholesaler, pharmacy..."
                                    className="searchFilter pl-10 w-full"
                                    value={searchValue}
                                    onChange={handleSearchChange}
                                    onFocus={handleSearchFocus}
                                />
                                {searchLoading && <Loader2 className="absolute right-3 top-1/2 -translate-y-1/2 h-4 w-4 animate-spin text-muted-foreground" />}
                                {showSearchResults && Array.isArray(searchDisplay) && searchDisplay.length > 0 && (
                                    <div 
                                        ref={searchResultsRef}
                                        className="absolute top-full left-0 right-0 mt-1 w-full bg-popover border rounded-md shadow-lg z-50 max-h-60 overflow-y-auto"
                                    >
                                        {searchDisplay.map((item, index) => {
                                            // Defensive check for each item
                                            if (!item || typeof item !== 'object') return null;
                                            
                                            return (
                                                <div
                                                    key={index}
                                                    onClick={() => handleSearchItemClick(item)}
                                                    className="flex items-center justify-between px-3 py-2 hover:bg-accent cursor-pointer text-sm border-b last:border-b-0"
                                                >
                                                    <span className="font-medium">
                                                        {item.cvalue || ''}
                                                    </span>
                                                    <span className="text-muted-foreground">
                                                        {item.cname || 'Unknown'}
                                                    </span>
                                                </div>
                                            );
                                        })}
                                    </div>
                                )}
                            </div>
                        </div>
                    </CardContent>
                </Card>

                {/* Filter Tags - Outside Card */}
                <FilterTag_API
                    Rolename={roleInfo.rolename}
                    wh_Id={roleInfo.wh_Id}
                    Roletype={roleInfo.roletype}
                    df={format(startDate, "yyyyMMdd")}
                    dt={format(endDate, "yyyyMMdd")}
                    handlechangea={handlechangea}
                    FilterTags={FilterTagList}
                    Loading={true}
                />

                <div className="grid grid-cols-1 2xl:grid-cols-2 gap-3">
                    {graphData.map((item, index) => (
                        <div key={`graph-widget-${index}`} className="min-h-[400px]">
                            {item.type === "Bar_List" && (
                                <BarListChart
                                    data={item}
                                    _Index={index}
                                    handlechangea={handlechangea}
                                />
                            )}
                            {item.type === "Column_Pie" && (
                                <ColumnPieChart
                                    data={item}
                                    _Index={index}
                                    handlechangea={handlechangea}
                                />
                            )}
                            {item.type === "List" && (
                                <ListChartWidget
                                    data={item}
                                    _Index={index}
                                    handlechangea={handlechangea}
                                />
                            )}
                            {item.type === "Heatmap" && (
                                <HeatmapChart
                                    data={item}
                                    _Index={index}
                                    handlechangea={handlechangea}
                                />
                            )}
                        </div>
                    ))}
                </div>
            </div>
        </PagesWrapper>
    );
}

export default PublicAPI;
